import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import fallbackResources from "./locales/resources";
import 'dayjs/locale/ca';
import 'dayjs/locale/oc-lnc';
import 'dayjs/locale/gl';
import 'dayjs/locale/eu';
import 'dayjs/locale/es';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import minMax from 'dayjs/plugin/minMax';
import dayjs from "dayjs";
import axios from "axios";


if (
  !import.meta.env.STORYBOOK
) {
  i18n.use(LanguageDetector);
}

i18n
  .use(initReactI18next)
  .init({
    resources: fallbackResources,
    debug: !import.meta.env?.SILENCE_I18N && import.meta.env.DEV,
    detection: {
      order: ['navigator'],
    },
    ns: ['common', 'fallback'],
    defaultNS: 'common',
    fallbackNS: 'fallback'
  });


i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng
});

axios.defaults.headers.common["Accept-Language"] = i18n.language;

document.documentElement.lang = i18n.language;

dayjs.locale(i18n.language);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(minMax);

export default i18n;
